export enum PaysafeAuthenticationPurpose {
  Instalment = 'INSTALMENT_TRANSACTION',
  Transaction = 'PAYMENT_TRANSACTION',
}
